export default __webpack_public_path__ + "static/media/o-nas-foto2.a5c93afa.jpg";